import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

// A full-viewport overlay, not an in-flow box. Some of the requests this covers take many
// seconds -- finalizing a whole store's inventory count is the worst case -- and the
// spinner is the only thing saying so. It used to sit at its static position with no
// z-index and no background, which left the button that started the request clickable
// underneath it: a user who thought nothing had happened fired the same destructive
// request a second time.
//
// The wash is doing work too. A bare transparent blocker reads as a frozen page; the
// dimming is what says "busy" rather than "broken".
export default function BlockingOverlay() {
    return (
        <Box
            data-testid='spinner-overlay'
            position='fixed'
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={theme => theme.zIndex.modal + 1}
            bgcolor='rgba(255, 255, 255, 0.6)'
            display='flex'
            justifyContent='center'
            flexDirection='column'
            alignItems='center'
        >
            <CircularProgress />
        </Box>
    )
}
